<div class="modal-container">
  <div class="modal-header">
    <h5 class="header-title">Delete/Detach: {{ elementType }}</h5>
  </div>

  <div class="modal-body">
    <!-- <h6 class="body-title">Are you sure you want to delete this {{ entityType }}?</h6> -->
    <p>Are you sure you want to delete this {{ elementType }}?</p>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" (click)="onDismiss()">No</button>
    <button class="btn-main" (click)="onSubmit()">Yes</button>
  </div>
</div>